// @core/api/endpoints/notifications/send_notification_smart.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SendNotificationSmartRequest,
  SendNotificationSmartResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Send smart notification based on user preferences
 * Intelligently routes notifications through the optimal channel based on user preferences, availability, and notification priority. Automatically selects the best delivery method.
 */
export async function SendNotificationSmart(
  data: SendNotificationSmartRequest,
  options?: RequestOptions
): Promise<SendNotificationSmartResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/notifications/smart`;
  const requestOptions = options;
  return client.post<SendNotificationSmartResponse>(requestPath, data, requestOptions);
}
